import { userInfoFrag } from "packages/client/src/app/utils/type/user.common-type";

export const getWarehouseMaterialsFrag = `
    id
    amount
    type
    date
    description
    workId
    work {
        id
        serviceId
        dateFrom
        workType
    }
    workerIds
    workers {
        ${userInfoFrag}
    }
    warehouseMaterialId
    warehouseMaterial {
        id
        name
    }
`
